export default __webpack_public_path__ + "static/media/026-Thor.5a83ef5a.svg";